import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api.ts';
import type { ConversationListPage, InboxRow } from '../inbox/types.ts';

/**
 * Latest chats waiting for a reply for the topbar bell. The key lives under `inbox-counts`, so it
 * refreshes on the same debounced realtime timer as the bell count (features/inbox/counts.ts).
 */
export function useNeedsReplyPreview(enabled: boolean, limit = 6) {
  return useQuery({
    queryKey: ['inbox-counts', 'bell-preview', limit] as const,
    queryFn: async ({ signal }): Promise<InboxRow[]> => {
      const page = await api.get<ConversationListPage>('/api/conversations', { query: { view: 'needs_reply', limit }, signal });
      const seen = new Set<string>();
      return [...(page.pinned ?? []), ...page.items].filter((r) => r.needsReply && !seen.has(r.id) && seen.add(r.id)).slice(0, limit);
    },
    enabled,
    staleTime: 20_000,
    refetchInterval: 120_000,
  });
}
